.tabs {
  height: 37px;
  --bs-nav-link-font-size: 14px;
  --bs-nav-tabs-border-color: rgb(var(--ex3-secondary-rgb));
  :global {
    .nav-link {
      height: 36px;
      --bs-nav-link-color: rgb(var(--bs-secondary-rgb));
      --bs-link-hover-color: white;
      --bs-nav-link-hover-color: white;
      --bs-nav-tabs-link-active-color: white;
      --bs-nav-tabs-link-active-bg: rgb(var(--bs-black-rgb));
      --bs-nav-tabs-border-radius: 0;
      --bs-nav-tabs-link-hover-border-color: rgb(var(--ex3-secondary-rgb));
      --bs-nav-tabs-link-active-border-color: rgb(var(--ex3-secondary-rgb));
      border-color: rgb(var(--ex3-secondary-rgb)) !important;
      &,
      &:hover,
      &.active {
        border-bottom: none;
        border-left-color: transparent !important;
        border-top-color: transparent !important;
        outline: none;
      }
    }
  }
  & + :global.tab-content {
    flex: 1;
    .tab-pane {
      height: 100%;
    }
  }
}

.towards {
  position: absolute;
  top: 0.35rem;
  right: 0.35rem;
}

.btn{
  height: 40px;
  border-radius: 6px;
  box-shadow: none !important;
  border-style:solid;
  border-width: 1px;
  .spinner{
    margin-left: 10px;
  }
  &.connect-btn {
    background: #1a2239 !important;
    border-color: transparent !important;
    color: #0099e6;
    font-weight: 400;
    box-shadow: none !important;
    &:hover,
    &:active,
    &:focus {
      background: #212a45 !important;
      border-color: #212a45 !important;
    }
  }
  &.btn-buy{
    background: rgba(15, 190, 175, 0.1);
    border-color: rgba(15, 190, 175, 0.4);
    &:hover,
    &:active,
    &:focus{
      background: rgba(15, 190, 175, 0.3);
    }
    &:disabled{
      color: rgba(15, 190, 175, 0.4);
    }
    .spinner{
      color: rgba(15, 190, 175, 0.4) !important;
    }
    
  }
  &.btn-sell{
    background: rgba(236, 73, 83, 0.1);
    border-color: rgba(236, 73, 83, 0.4);
    &:hover,
    &:active,
    &:focus{
      background: rgba(236, 73, 83, 0.3);
    }
    &:disabled{
      color: rgba(236, 73, 83, 0.4);
    }
  }
  .spinner{
    color: rgba(236, 73, 83, 0.4) !important;
  }
}


.trading-form-wrap{
  padding-bottom: 20px;
}
.form-wrap{
  :global{
    .badge{
      background-color: #212A45 !important;
      font-weight: 400;
    }
  }
}
.header{
  height: 20px;
  margin: 20px 0 10px;
}
.footer{
  height: 20px;
  margin: 8px 0 12px;
}
.input-group{
  height: 36px;
  margin-bottom: 4px;
  :global{
    .form-control{
      box-shadow: none !important;
    }
  }
}

.RangeInput-wrap{
  height: 1rem;
  display: flex;
  align-items: center;
}
.RangeInput{
  background-color: #353E59;
  height: 2px;
  input[type="range"]{
    transform: translateY(-14px);
    &::-webkit-slider-runnable-track {
      height: 2px;
      background: rgb(var(--bs-dark-rgb));
    }
    &::-webkit-slider-thumb {
      height: 12px;
      width: 12px;
      background: #5F7195;
      border-radius: 2px;
    }
  }
}
@-moz-document url-prefix(){
  input[type="range"]{
    &::-moz-range-track{
      height: 3px;
      background: rgb(var(--bs-dark-rgb));
    }
    &::-moz-range-thumb {
      border:none;
      height: 12px;
      width: 12px;
      background: #5F7195;
      border-radius: 2px;
      transform: translateY(2px);
    }
  }
}